// export const getPublicTechnicalReports = (state) => state.publicTechnicalReports;
export const getPublicTechnicalReportsYears = (state) => state.publicTechnicalReportsYears;